import { IHandleSearchParams, ISearchGrouped } from "@model/Search.model";
import { AxiosCalls } from "../Functions/AxiosCalls";
import { handleDefaultApiErrors } from "Utils/Global/apiErrorHandling";

export class SearchService {
    async handleSearch({
        q,
        limit,
        setApiError,
        setLoading,
    }: IHandleSearchParams): Promise<ISearchGrouped | null> {
        setLoading(true);
        setApiError(null);

        try {
            const params = new URLSearchParams();
            if (q && q.trim()) params.set("q", q.trim());
            if (limit != null) params.set("limit", String(limit));

            const url = `/search${params.toString() ? `?${params.toString()}` : ""}`;

            const resp = await AxiosCalls.Get<{ message: string; data: ISearchGrouped }>(
                url,
                ""
            );

            return resp?.data?.data ?? { categories: [], products: [], services: [] };
        } catch (err) {
            setApiError(handleDefaultApiErrors(err));
            return null;
        } finally {
            setLoading(false);
        }
    }
}
